import { MutationTree } from "vuex";
import { UserState, User } from "./model";

const mutations: MutationTree<UserState> = {
  setUsers(state, users: User[]) {
    state.users = users
  },
  addUser(state, user: User) {
    state.users.push(user)
  },
  updateUser(state, user: User) {
    const c = state.users.find(c => c.id === user.id);
    Object.assign(c, user);
  },
  deleteUser(state, id: string) {
    state.users = state.users.filter(user => user.id !== id)
  }
}

export default mutations;
